import { gql } from '@apollo/client'

export const DAILY_RATE = gql`
  query getDailyRate {
    getDailyRate {
      usdDailyRate
      eurDailyRate
    }
  }
`
